/**
 * Tri-Axis XYZ Logo — three intersecting orthogonal planes
 * - Blue plane (X / vertical-right)
 * - Green plane (Y / vertical-left)
 * - Orange plane (Z / horizontal)
 * Arrow points down-left (origin axis).
 *
 * Animation: idle subtle "breathing" rotation; on parent .group:hover each
 * plane shifts & rotates around the shared origin for a calibration feel.
 */
export default function TriAxisLogo({ size = 36, className = "", testid = "tri-axis-logo" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={`tri-axis-logo ${className}`}
      data-testid={testid}
      aria-label="Tri-Axis XYZ logo"
      role="img"
    >
      <defs>
        <pattern id="tri-grid" width="6" height="6" patternUnits="userSpaceOnUse">
          <path d="M 6 0 L 0 0 0 6" fill="none" stroke="#0F172A" strokeWidth="0.4" opacity="0.55" />
        </pattern>
      </defs>

      {/* Z plane (horizontal / orange) — back */}
      <g className="plane-z">
        <polygon points="6,55 70,55 94,42 30,42" fill="#F97316" opacity="0.78" />
        <polygon points="6,55 70,55 94,42 30,42" fill="url(#tri-grid)" />
      </g>

      {/* Y plane (vertical-left / green) */}
      <g className="plane-y">
        <polygon points="32,12 60,12 60,92 32,92" fill="#16A34A" opacity="0.72" />
        <polygon points="32,12 60,12 60,92 32,92" fill="url(#tri-grid)" />
      </g>

      {/* X plane (vertical-right / blue) */}
      <g className="plane-x">
        <polygon points="18,20 86,20 86,82 18,82" fill="#1D4ED8" opacity="0.55" />
        <polygon points="18,20 86,20 86,82 18,82" fill="url(#tri-grid)" />
      </g>

      {/* Y plane front crossover */}
      <g className="plane-y">
        <polygon points="40,52 58,52 58,92 40,92" fill="#16A34A" opacity="0.75" />
        <polygon points="40,52 58,52 58,92 40,92" fill="url(#tri-grid)" />
      </g>

      {/* Z plane front strip */}
      <g className="plane-z">
        <polygon points="18,62 70,62 86,55 34,55" fill="#F97316" opacity="0.8" />
        <polygon points="18,62 70,62 86,55 34,55" fill="url(#tri-grid)" />
      </g>

      {/* Origin axis arrow */}
      <g className="arrow">
        <line x1="62" y1="50" x2="14" y2="78" stroke="#0F172A" strokeWidth="2.2" strokeLinecap="round" />
        <polygon points="14,78 22,76 19,82" fill="#0F172A" />
      </g>
    </svg>
  );
}
